import type { BrandTheme, PartialBrandTheme } from '../../types/BrandTheme'
import { brandTheme } from '../../types/BrandTheme'
import merge from 'deepmerge'
import { dirname } from 'path'
import {
  resolveFontFamily,
  resolveThemeUIFontSizes,
} from '@jotta/ui/FontConfig'

import './theme.css'

export const tele2theme: BrandTheme = merge<BrandTheme, PartialBrandTheme>(
  brandTheme,
  {
    branding: {
      brand: 'COMHEM',
      themedir: dirname(new URL(import.meta.url).pathname),
      staticDir: 'tele2',
      height: 32,
      learnMoreLinkWaitlist: 8290194,
      learnMoreLinkSearch: 8290382,
    },
    fontSizes: resolveThemeUIFontSizes('tele2'),
    fonts: resolveFontFamily('tele2'),
    colors: {
      text: '#17181A',
      background: '#fff',
      blackIshBg: '#2b2b2b',
      primary: '#030F1C',
      slateGray: '#505050',
      secondary: '#fff',
      accent: '#666870',
      accentText: '#fff',
      focus: '#030F1C',
      focusDark: '#fff',
      border: '#E9E9E9',
      lightBlueBg: '#4990E2',
      grayHeading: '#4A4A4A',
      graySlateOpacityBg: 'rgba(69,67,76,.8)',
      purpleHueGray: '#45434c',
      warningText: '#333',
      blackBg: '#030f1c',
      danger: '#ef3138',
    },
    buttons: {
      primary: {
        borderColor: 'text',
        backgroundColor: 'text',
        border: '1px solid #DDDDDE',
        borderRadius: '2px',
        color: 'accentText',
        '--focus-color': 'var(--color-text)',
        fontSize: 2,
        fontWeight: 'light',
        lineHeight: '34px',
        padding: '0 8px',
        minWidth: '128px',
        width: 'auto !important',
      },
      secondary: {
        variant: 'buttons.primary',
        color: '#58585B',
        background: '#fff',
        '&:not(:disabled):hover': {
          filter: 'brightness(0.9)',
        },
      },
      download: {
        backgroundColor: 'black',
      },
      replyButton: {
        color: 'var(--color-carousel-background)',
      },
      replyButtonDarkMode: {
        color: 'background',
      },
    },
    forms: {
      input: {
        fontWeight: 'body',
        fontSize: 2,
        color: 'black',
        '&:disabled': {
          color: 'rgba(0,0,0,.42)',
          borderBottomStyle: 'dotted',
          backgroundColor: 'transparent',
        },
        ':focus': { borderBottomColor: 'lightBlueBg' },
      },
      toggle: {
        '&:checked::before': {
          backgroundColor: 'slateGray',
        },
        '&:checked::after': {
          backgroundColor: 'slateGray',
        },
      },
      checkbox: {
        fontSize: '11px',
        borderRadius: '3px',
        border: '1px solid',
      },
    },
    layout: {
      appHeader: {
        backgroundColor: 'background',
      },
      appHeaderHamburger: {
        color: 'warningText',
        '& > svg': {
          '&:hover': {
            color: 'warningText',
            opacity: 1,
          },
        },
      },
      modalBackgroundPrimary: {
        backgroundColor: 'rgba(15, 90, 185, 0.9)',
      },
    },
    cards: {
      photoUploadSuccess: {
        '--action-button-color': '#fff',
        '--action-button-text-opacity': 1,
        backgroundColor: 'slateGray',
      },
      photoUpload: {
        '--action-button-text-opacity': 1,
      },
    },
    styles: {
      avatar: {
        borderRadius: '100%',
        fontSize: 1,
        fontWeight: 'body',
        width: '36px',
        height: '36px',
        lineHeight: '36px',
      },
      h1: {
        fontWeight: 500,
        color: 'grayHeading',
        fontFamily: 'Tele2Sans',
        fontSize: '23px',
      },
      h2: {
        fontSize: '17px',
        fontWeight: 500,
        margin: '0 0 20px',
        padding: 0,
        color: 'purpleHueGray',
      },
      h4: {
        color: 'warningText',
      },
      p: {
        color: 'graySlateOpacityBg',
        fontSize: 2,
      },

      //Used on download page
      downloadPageHeader: {
        color: 'black',
      },
      downloadSvg: {
        color: 'black',
      },
      fileIcon: {
        '--file-icon-border-color': '#b3b3b3',
        '--folder-icon-fill': '#f0f0f0',
        //filter: 'grayscale(1)',
      },
      fileinfo: {
        fontWeight: 300,
      },
      timelineHeading: {
        fontSize: '20px',
        fontWeight: 500,
        color: '#45434c',
      },
      addMoreSvg: {
        color: 'blackBg',
        width: '24px',
        height: '24px',
      },
      newAlbumP: {
        fontSize: '15px',
        opacity: 0.8,
        fontWeight: 500,
        color: 'purpleHueGray',
      },
      defaultProfilePicSvg: {
        color: '#2A4058',
      },
    },
  },
)
export default tele2theme
